import { IonButton, IonIcon, IonInput, IonLabel } from "@ionic/react";
import React, { useEffect, useState } from "react";
import { CONSTANTS } from "../../../../constants";
import "./Settings.scss";
import { StorageService } from "../../../../services/storage.service";
import { useHistory } from "react-router";
import _ from "lodash";
import { utilService } from "../../../../services";
import { moon, sunny } from "ionicons/icons";
import CustomToggle from "./components/CustomToggle";
import { settingsService } from "./Settings.service";
import { pushNotificationService } from "../../../../services/PushNotification.service";
import { dataTransferService } from "../../../../services/dataTransferService";
import { menuService } from "../../../../components/Shared/Menu/Menu.service";
import { useToast } from "@agney/ir-toast";
// (Node's timers module was imported here; the browser global is what these calls want.)
import { Capacitor } from "@capacitor/core";
import { StatusBar, Style } from "@capacitor/status-bar";
import { useDarkMode } from "../../../../helpers/ThemeContext";
import { rolePermissionsService } from "../../../../services/rolePermissions.service";
import { loggedInUserService } from "../../../../services/loggedInUser.service";
import { IonSelect, IonSelectOption } from "@ionic/react";
import i18n from "../../../../locales/i18n/i18n";
import { LANGUAGES } from "../../../../locales/i18n/languages";
import { useTranslation } from "react-i18next";

interface SettingsProps {
  onCancel: () => void;
}

const Settings: React.FC<SettingsProps> = (props) => {
  const { t } = useTranslation("settings");
  const [unavailability, setUnavailability] = useState(false);
  const [n2nLiting, setN2NLiting] = useState(false);
  var [disableBtn, setDisableBtn] = useState(true);
  var [networkValidation, setNetworkValidation] = useState("");
  var [networkCode, setNetworkCode] = useState("");
  var [savePassword, setSavePassword] = useState(false);
  var [googleAutoSync, setGoogleAutoSync] = useState(false);
  var [outlookAutoSync, setOutlookAutoSync] = useState(false);
  const [syncData, setSyncData] = useState(false);
  const [isOutlookTokenGenerated, setIsOutlookIsTokenGenrated] =
    useState(false);
  const [isGoogleTokenGenerated, setIsGoogleIsTokenGenrated] = useState(false);
  const [outlookToggleButton, setOutlookToggleButton] = useState(false);
  const [googleToggleButton, setGoogleToggleButton] = useState(false);
  const [googleAutoSyncDate, setGoogleAutoSyncDate]: any = useState();
  const [outlookAutoSyncDate, setOutlookAutoSyncDate]: any = useState();
  const [themeType, setTheme] = useState(false);
  const [phaseStatusDetails, setPhaseStatusDetails]: any = useState([]);
  const [versionDetails, setVersionDetails]: any = useState("v1.2.3");
  const [rolePermissions, setRolePermissions] = useState<any>(Object);
  const [isN2nPermission, setisN2nPermission] = useState<any>(false);
  // const [isONLinking, setisONLinking] = useState<any>(false);
  const [language, setLanguage] = useState(i18n.language || "en");
  

  const [isChecked, setIsChecked] = useState(false);
  const [email, setEmail] = useState("");
  const [isOnUSer,setIsOnUSer] = useState(false)
  const [isDnUSer,setIsDnUSer] = useState(false)

const LANGUAGE_FLAGS: Record<string, string> = {
  en: "/assets/images/English.svg",
  fr: "/assets/images/France.png",
  ar: "/assets/images/Algeria.svg",
};

// Derived from the shared LANGUAGES list so this switcher, the header switcher
// and i18next cannot fall out of step.
const languages = LANGUAGES.map((option) => ({
  code: option.value,
  label: t(option.labelKey),
  flag: LANGUAGE_FLAGS[option.value],
}));

  useEffect(() => {
    const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
      setIsOnUSer(data?.userData?.roleBasedPermission?.isOnUser)
      setIsDnUSer(data?.userData?.roleBasedPermission?.isDnUser)
    });
    return () => subscription.unsubscribe();
  }, [])
  
  const handleSubmit = async () => {
    console.log("Submitted email:", email);
    const params = {
      email: email
    }
    const respResult = await settingsService.saveONEmailLinking(
      params
    );
    
    if (respResult.isSuccess) {
      Toast.success(respResult?.message);
    }
    else {
      Toast.error(respResult?.message);
    }

  };

const handleLanguageChange = (value: string) => {
  setLanguage(value);
  i18n.changeLanguage(value);

  localStorage.setItem("appLanguage", value);

  // Optional: reload page so APIs reload with new header
  window.location.reload();
};


  let history = useHistory();
  const Toast = useToast();
  const { isDarkModeContext, setIsDarkMode } = useDarkMode();

  // getting role permissions
  useEffect(() => {
    const rolePermissionData =
      rolePermissionsService.getRolePermissionsDetails();
    setRolePermissions(rolePermissionData);
  }, []);

  useEffect(() => {
    const passwordStatus = utilService.getSavePasswordStatus();
    setSavePassword(passwordStatus);
    getAutoSyncInitialValues();
    const isDarkMode = getThemeStatusFromStorage();
    toggleDarkModeHandler(isDarkMode);
    setTheme(isDarkMode);
    const unavailabilityStatusFromStorage = getUnavilabilityStatusFromStorage();
    setUnavailability(unavailabilityStatusFromStorage);
    //To check version details
    getPhaseStatusDetails();
  }, []);

  useEffect(() => {
    const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
      setisN2nPermission(data?.userData?.n2nActivation)
          // setIsOnUSer(data?.userData?.n2nActivation)
    });
    
    // Module-level Subject: without this, every mount left a live
    // handler behind, so one update was handled once per visit.
    return () => subscription.unsubscribe();
  }, []);


  useEffect(() => {
    const subscription = loggedInUserService.loggedInUserData.subscribe((data: any) => {
      setN2NLiting(data?.userData?.n2nUserListing)
    });
    
    // Module-level Subject: without this, every mount left a live
    // handler behind, so one update was handled once per visit.
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    if (!_.isEmpty(phaseStatusDetails)) {
      updateVersionDetils();
    }
  }, [phaseStatusDetails]);

  const getAutoSyncInitialValues = async () => {
    const respGetAutoSyncInitialvalues: any =
      await settingsService.getAutoInitialValues();
    if (respGetAutoSyncInitialvalues.isSuccess) {
      const outlookIsTokenGenratedVar =
        respGetAutoSyncInitialvalues?.result?.result?.[0]?.outlook_calendar
          .is_token_generated;
      const outlookIsAutoSyncVar =
        respGetAutoSyncInitialvalues?.result?.result?.[0]?.outlook_calendar
          .is_auto_synced;
      setIsOutlookIsTokenGenrated(outlookIsTokenGenratedVar);
      const googleAutoSyncDate =
        respGetAutoSyncInitialvalues?.result?.result?.[0]?.google_calendar;
      setGoogleAutoSyncDate(googleAutoSyncDate);
      const outlookAutoSyncDate =
        respGetAutoSyncInitialvalues?.result?.result?.[0]?.outlook_calendar;
      setOutlookAutoSyncDate(outlookAutoSyncDate);
      setOutlookAutoSync(
        respGetAutoSyncInitialvalues?.result?.result?.[0]?.outlook_calendar
          .is_auto_synced
      );
      if (outlookIsAutoSyncVar == true && outlookIsTokenGenratedVar == true) {
        setOutlookToggleButton(true);
      } else {
        setOutlookToggleButton(false);
      }
      sessionStorage.setItem(
        "toggleOutlook",
        new Boolean(outlookToggleButton).toString()
      );
      setGoogleAutoSync(
        respGetAutoSyncInitialvalues?.result?.result?.[0]?.google_calendar
          .is_auto_synced
      );
      const googleIsTokenGenratedVar =
        respGetAutoSyncInitialvalues?.result?.result?.[0]?.google_calendar
          .is_token_generated;

      const googleIsAutoSyncVar =
        respGetAutoSyncInitialvalues?.result?.result?.[0]?.google_calendar
          .is_auto_synced;
      setIsGoogleIsTokenGenrated(googleIsTokenGenratedVar);
      if (googleIsAutoSyncVar == true && googleIsTokenGenratedVar == true) {
        setGoogleToggleButton(true);
      } else {
        setGoogleToggleButton(false);
      }
      sessionStorage.setItem(
        "toggleGoogle",
        new Boolean(googleToggleButton).toString()
      );
    } else {
      console.log("error");
    }
  };

  useEffect(() => {
    setTimeout(async () => {
      const googleAutoSync: any = await settingsService.getAutoInitialValues();
      setIsOutlookIsTokenGenrated(
        googleAutoSync?.result?.result?.[0]?.outlook_calendar.is_token_generated
      );
      setOutlookAutoSync(
        googleAutoSync?.result?.result?.[0]?.outlook_calendar.is_auto_synced
      );

      const outlookIsTokenGenratedVar =
        googleAutoSync?.result?.result?.[0]?.outlook_calendar.is_token_generated;
      const outlookIsAutoSyncVar =
        googleAutoSync?.result?.result?.[0]?.outlook_calendar.is_auto_synced;

      if (outlookIsTokenGenratedVar == true && outlookIsAutoSyncVar == true) {
        setOutlookToggleButton(true);
      } else {
        setOutlookToggleButton(false);
      }
      sessionStorage.setItem(
        "toggleOutlook",
        new Boolean(outlookToggleButton).toString()
      );
      setGoogleAutoSync(
        googleAutoSync?.result?.result?.[0]?.google_calendar.is_auto_synced
      );
      const googleIsTokenGenratedVar =
        googleAutoSync?.result?.result?.[0]?.google_calendar.is_token_generated;
      setIsGoogleIsTokenGenrated(googleIsTokenGenratedVar);

      const googleIsAutoSyncVar =
        googleAutoSync?.result?.result?.[0]?.google_calendar.is_auto_synced;
      setIsGoogleIsTokenGenrated(googleIsTokenGenratedVar);
      if (googleIsAutoSyncVar == true && googleIsTokenGenratedVar == true) {
        setGoogleToggleButton(true);
      } else {
        setGoogleToggleButton(false);
      }

      sessionStorage.setItem(
        "toggleGoogle",
        new Boolean(googleToggleButton).toString()
      );
    }, 1000);
  }, []);

  const updateVersionDetils = () => {
    let phase2Version = "2";
    let phase3Version = "3";
    if (
      phaseStatusDetails.phase3Status === 2 ||
      phaseStatusDetails.phase3Status === 3
    ) {
      phase3Version = "0";
    }
    if (
      phaseStatusDetails.phase2Status === 2 ||
      phaseStatusDetails.phase2Status === 3
    ) {
      phase2Version = "0";
    }
    let finalVersion = "v1." + phase2Version + "." + phase3Version;
    setVersionDetails(finalVersion);
  };

  const getThemeStatusFromStorage = () => {
    const savePasswordStatus = utilService.getSavePasswordStatus();
    const isDarkMode = StorageService.getStorageItem(
      CONSTANTS.STORAGE[true === savePasswordStatus ? 1 : 0],
      "isDarkMode",
      true
    );
    if (isDarkMode === "true") {
      return true;
    } else {
      return false;
    }
  };

  const getUnavilabilityStatusFromStorage = () => {
    const savePasswordStatus = utilService.getSavePasswordStatus();
    const unavailabilityStatusFromStorage = StorageService.getStorageItem(
      CONSTANTS.STORAGE[true === savePasswordStatus ? 1 : 0],
      "unavilabilityStatus",
      true
    );
    if (unavailabilityStatusFromStorage === "true") {
      return true;
    } else {
      return false;
    }
  };

  const toggleDarkModeHandler = (status: boolean) => {
    if (Capacitor.getPlatform() === "ios") {
      if (status === true) {
        StatusBar.setStyle({ style: Style.Dark });
      } else {
        StatusBar.setStyle({ style: Style.Light });
      }
    }
    document.body.className = status ? "dark-theme" : "light-theme";
    setTheme(status);
    changeThemeStatusStorage(status);
    setIsDarkMode(status);
  };

  const toggleAutoSync = (e: boolean, data: any) => {
    if (data == 4) {
      data = 1;
    } else if (data == 5) {
      data = 2;
    }
    setAutoSyncStatus(e, data);
  };

  const changeThemeStatusStorage = (status: boolean) => {
    const savePasswordStatus = utilService.getSavePasswordStatus();
    var currentStorage;
    if (savePasswordStatus) {
      currentStorage = localStorage;
    } else {
      currentStorage = sessionStorage;
    }
    StorageService.setStorageItem(
      currentStorage,
      {
        isDarkMode: status,
      },
      true
    );
  };

  const changeUnavailabilityStatusStorage = (status: boolean) => {
    const savePasswordStatus = utilService.getSavePasswordStatus();
    var currentStorage;
    if (savePasswordStatus) {
      currentStorage = localStorage;
    } else {
      currentStorage = sessionStorage;
    }
    StorageService.setStorageItem(
      currentStorage,
      {
        unavilabilityStatus: status,
      },
      true
    );
  };

  const changeStorage = () => {
    let saveStorage: any;
    let currStorage: any;
    const getSavePasswordStatus = utilService.getSavePasswordStatus();
    if (getSavePasswordStatus) {
      currStorage = localStorage;
    } else {
      currStorage = sessionStorage;
    }
    if (!getSavePasswordStatus) {
      saveStorage = localStorage;
    } else {
      saveStorage = sessionStorage;
    }

    const keys = CONSTANTS.STORAGE_KEYS;
    const storageData: any = {};
    for (const key of keys) {
      storageData[key] = StorageService.getStorageItem(currStorage, key);
    }
    StorageService.setStorageItem(saveStorage, storageData);
    StorageService.setStorageItem(localStorage, {
      savePassword: !getSavePasswordStatus,
    });
    StorageService.removeStorageItem(
      CONSTANTS.STORAGE[true === getSavePasswordStatus ? 1 : 0],
      keys
    );
  };

  const changeUnavailable = (e: any) => {
    UpdateUnavailabilityStatus(e);
  };

  const handleN2NListingToggle = async (e: any) => {

    const payload = {
      user_guid: utilService.getLoggedUserGuid(),
      is_activated: e
    }
    StorageService.setStorageItem(
      localStorage,
      {
        isN2NActivated: e,
      },
      true
    );
    const response = await menuService.activateN2NListing(payload)
    if (response?.isSuccess) {
      setN2NLiting(e)
      Toast.success(response?.message);
      loggedInUserService.setLoggedInUserData()
    } else {
      Toast.error(response?.message);
    }
  }

  const confirmToast = (data: any, e: any) => {
    switch (data) {
      case CONSTANTS.SETTING_OPTIONS.SAVE_PASSWORD:
        changeStorage();
        setSavePassword(e);
        break;
      case CONSTANTS.SETTING_OPTIONS.UNAVAILABLE_WHEN_NOT_ON_CALL:
        changeUnavailable(e);
        setUnavailability(e);
        break;
      case CONSTANTS.SETTING_OPTIONS.TOGGLE_THEME:
        toggleDarkModeHandler(e);
        break;

      case CONSTANTS.AUTO_SYNC.GOOGLE:
        toggleAutoSync(e, data);
        setGoogleToggleButton(e);
        break;

      case CONSTANTS.AUTO_SYNC.OUTLOOK:
        toggleAutoSync(e, data);
        setOutlookToggleButton(e);
        break;

      case "N2NListing":
        handleN2NListingToggle(e);
        break;
    }
  };

  const onChangeInput = (value: any) => {
    setNetworkValidation("");
    if (_.isEmpty(value.trim())) {
      setDisableBtn(true);
    } else {
      setNetworkCode(value.trim());
      setDisableBtn(false);
    }
  };

  const changeNetwork = () => {
    logOff();
  };

  const logOff = () => {
    logout();
  };

  // Awaited rather than raced against a one-second timer: logoutSession()
  // navigates away, which would cancel the revoke while it was in flight.
  const logout = async () => {
    await pushNotificationService.deleteToken();
    logoutSession();
  };

  const logoutSession = async (params?: any) => {
    const local_keys = ["savePassword", "isLoggedIn"];
    const storage_keys = ["token", "username"];

    const savePassword = utilService.getSavePasswordStatus()
      ? StorageService.getStorageItem(localStorage, "savePassword")
      : undefined;

    StorageService.removeStorageItem(
      CONSTANTS.STORAGE[true === savePassword ? 1 : 0],
      storage_keys
    );

    StorageService.removeStorageItem(localStorage, local_keys);
    // Remove all keys except 'applanguage' from localStorage and sessionStorage
    const preserveKey = 'appLanguage';
    Object.keys(localStorage).forEach((key) => {
      if (key !== preserveKey) {
        localStorage.removeItem(key);
      }
    });
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== preserveKey) {
        sessionStorage.removeItem(key);
      }
    });
    history.push({
      pathname: "/login",
      state: { networkCodeDetails: networkCode },
    });
  };

  const upgradeFeature = () => {
    dataTransferService.transferUpdateBtnClickAction(true);
  };

  const UpdateUnavailabilityStatus = async (e: any) => {
    const params = getUnavilabilityParams(e);
    const respUnavilabilityStatus: any =
      await settingsService.changeAvailabilityStatus(params);
    if (respUnavilabilityStatus.isSuccess) {
      changeUnavailabilityStatusStorage(e);
    } else {
      console.log("error");
    }
  };
  const setAutoSyncStatus = async (e: any, data: number) => {
    const params = getAutoSyncParams(e, data);
    const respUAutoSyncStatus: any = await settingsService.setAutoSyncStatus(
      params
    );

    if (respUAutoSyncStatus?.isSuccess) {
      if (respUAutoSyncStatus?.result?.[0]?.calendar_type == "1") {
        if (
          respUAutoSyncStatus?.result?.[0]?.is_auto_synced &&
          respUAutoSyncStatus?.result?.[0]?.is_token_generated
        ) {
          setGoogleToggleButton(true);

          Toast.success(respUAutoSyncStatus?.message);
        } else {
          setTimeout(() => {
            setGoogleToggleButton(false);

            Toast.success(respUAutoSyncStatus?.message);
          }, 300);
        }
      } else if (respUAutoSyncStatus?.result?.[0]?.calendar_type == "2") {
        if (
          respUAutoSyncStatus?.result?.[0]?.is_auto_synced &&
          respUAutoSyncStatus?.result?.[0]?.is_token_generated
        ) {
          setOutlookToggleButton(true);
          Toast.success(respUAutoSyncStatus?.message);
        } else {
          setTimeout(() => {
            setOutlookToggleButton(false);

            Toast.success(respUAutoSyncStatus?.message);
          }, 300);
        }
      }

      sessionStorage.setItem(
        "result",
        JSON.stringify(respUAutoSyncStatus?.result)
      );
    } else {
      Toast.error(CONSTANTS.MESSAGES.AUTO_SYNC_ALERT_ERROR);
    }
  };
  const getUnavilabilityParams = (isChecked: boolean) => {
    return {
      guid: utilService.getLoggedUserGuid(),
      unavailable_when_not_oncall: isChecked,
      reg_code: utilService.getNetwork(),
    };
  };

  const getAutoSyncParams = (isChecked: boolean, calendarType: number) => {
    return {
      guid: utilService.getLoggedUserGuid(),
      is_auto_synced: isChecked,
      calendar_type: calendarType,
      is_from_settings: true,
      reg_code: utilService.getNetwork(),
    };
  };

  const getPhaseStatusDetails = async () => {
    const params = "";
    const respPhaseDetailsResult: any = await menuService.getPhaseDetails(
      params
    );
    if (respPhaseDetailsResult.isSuccess && respPhaseDetailsResult.result) {
      setPhaseStatusDetails(respPhaseDetailsResult.result?.[0]);
    } else {
      console.log("error");
      menuService.handleErrorResponse();
    }
  };

  return (
    <div className="settings-container">
      <div className="settings-back" onClick={props.onCancel}>
        <div className="settings-back-icon icon-back"></div>
    <div className="settings-back-header">{t("settings")}</div>
      </div>

<div className="language-container">

  <div className="language-header">
    <IonLabel>{t("language")}</IonLabel>
  </div>

  <div className="language-select">

    <IonSelect
      value={language}
      interface="popover"
      onIonChange={(e) => handleLanguageChange(e.detail.value)}
    >
      {languages.map((lang) => (
        <IonSelectOption key={lang.code} value={lang.code}>
          {lang.label}
        </IonSelectOption>
      ))}
    </IonSelect>

  </div>

</div>

      <div className="theme-selector-container">
        <div className="theme-header">
<IonLabel>{t("darkTheme")}</IonLabel>
        </div>
        <div
          className={`toggle-button-wrapper ${themeType ? "toggle-dark-mode" : ""
            }`}
        >
          {themeType && (
            <div className="toggle-image">
              <IonIcon slot="start" icon={sunny} />
            </div>
          )}
          <CustomToggle
            isSelected={themeType}
            type={CONSTANTS.SETTING_OPTIONS.TOGGLE_THEME}
            confirmToast={confirmToast}
          ></CustomToggle>
          {!themeType && (
            <div className="toggle-image">
              <IonIcon slot="start" icon={moon} />
            </div>
          )}
        </div>
      </div>
      <div className="save-password-container">
        <div className="save-password-header">
<IonLabel>{t("savePassword")}</IonLabel>
        </div>
        <div className="save-password-toggle-icon">
          <CustomToggle
            isSelected={savePassword}
            type={CONSTANTS.SETTING_OPTIONS.SAVE_PASSWORD}
            confirmToast={confirmToast}
          ></CustomToggle>
        </div>
      </div>

      {!isOnUSer && <div className="unavailability-container">
        <div className="unavailability-header">
      <IonLabel>{t("unavailableWhenNotOnCall")}</IonLabel>
        </div>
        <div className="unavailability-toggle-icon">
          <CustomToggle
            isSelected={unavailability}
            type={CONSTANTS.SETTING_OPTIONS.UNAVAILABLE_WHEN_NOT_ON_CALL}
            confirmToast={confirmToast}
          ></CustomToggle>
        </div>
      </div>}

      {isN2nPermission &&
        <div className="unavailability-container">
          <div className="unavailability-header">
         <IonLabel>{t("n2nListing")}</IonLabel>
          </div>
          <div className="unavailability-toggle-icon">
            <CustomToggle
              isSelected={n2nLiting}
              type={"N2NListing"}
              confirmToast={confirmToast}
            ></CustomToggle>
          </div>
        </div>
      }

      {!isOnUSer&&!isDnUSer &&



      <div
        className="unavailability-container"
        style={{
          // padding: "12px",
          // border: "1px solid #c7cace",
          borderRadius: "8px",
          // background: "#f9f9f9",
          maxWidth: "400px",
          padding: "12px 27px 12px 15px",
          justifyContent: "space-between"
        }}
      >
        {/* Header + Checkbox inline */}
        {/* <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      > */}
        <IonLabel style={{ fontSize: "14px", fontWeight: 300, color: "var(--font-color-primary)" }}>
    <IonLabel>{t("onEmailLinking")}</IonLabel>
        </IonLabel>
        <input color="green"
          type="checkbox"
          checked={isChecked}
          onChange={(e) => setIsChecked(e.target.checked)}
          style={{ width: "18px", height: "18px", cursor: "pointer" }}
        />
        {/* </div> */}

        {/* Show text field + button only when checked */}

      </div>
}
      {isChecked && (
        <div style={{ marginTop: "12px" }}>
          <IonInput
            placeholder={t("enterEmail")}
            value={email}
            onIonChange={(e) => setEmail(e.detail.value!)}
            className="custom-input"
            style={{
              marginBottom: "10px",
              border: "1px solid #ffffff",
              borderRadius: "6px",
              padding: "6px 8px",
              fontSize: "14px",
              color: "#11161c", // text color
              "--placeholder-color": "#ffffffff",
              background: '#d93a45' // 👈 placeholder color
            }}
          />
          <IonButton
            onClick={handleSubmit}
            style={{
              borderRadius: "6px",
              "--background": "#05b9bb",
              width: "100px",
              color: "#fff",
              fontWeight: 500, float: "right",
              textTransform: "none", // keeps the text as 'Submit', not uppercase
              marginTop: "8px", 
              '--border-color': '#05b9bb'     // adds spacing from the input
            }}
          >
         {t("submit")}
          </IonButton>
        </div>
      )}

    </div>
  );
};
export default Settings;
